<template>
  <div class="bodys">
    <div class="container section" id="contact">
      <h1 class="text-center">
        <span class="glyphicon glyphicon-question-sign"></span> お問い合わせ
      </h1>
      <div class="contact_ul">
        <span class="box-title">J-direct box</span>
        <ul>
          <li>
            <span class="glyphicon glyphicon-envelope"></span>
            　<a href="mailto:info@d-provider.com">
                info@d-provider.com
              </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {},
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.bodys {
  margin: 0 auto;
  width: 1170px;
  height: 66.8vh;
  margin-top: 80px;
  margin-bottom: 80px;
  padding-top: 1px;
}
h1, .h1, h2, .h2, h3, .h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}
.container{
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.container h1 {
  margin-top: 2em;
  margin-bottom: 1em;
  font-size: 36px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}
.contact_ul {
  width: 60%;
  position: relative;
  margin: 2em auto 4em;
  padding: 2em 1em 1em;
  border: solid 3px #ccc;
  border-radius: 8px;
}
.contact_ul .box-title {
  position: absolute;
  display: inline-block;
  top: -10px;
  left: 10px;
  padding: 0 9px;
  line-height: 1;
  font-size: 1.2em;
  background: #FFF;
  color: #FBA848;
  font-weight: bold;
}
ul li{
  list-style-type:none;
  margin-bottom: 1em;
  font-size: 1.2em
}
.container .company {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/contact/index.vue